<div class="card-placa" [matTooltip]="placa">
  <div class="card-placa-titulo">
    <span class="header">BRASIL</span>
    <img [src]="flag" alt="Brasil" class="flag"/>
  </div>
  <div class="card-placa-subtitulo">
    <span class="ellipsis-1" >{{placa}}</span>
  </div>
</div>
